var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-page"},[_c('Icon',{staticClass:"success-icon",attrs:{"name":"checked"}}),_c('div',{staticClass:"describe"},[_vm._v(_vm._s(_vm.describe))]),_c('Button',{staticClass:"btn",attrs:{"type":"info"},on:{"click":_vm.clickInfo}},[_vm._v(_vm._s(_vm.btnText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }